<div class="container my-3">
  <!-- <h1 class="mb-4">Edit Company</h1> -->
  <div class="row mt-4">
    <div class="col-6">
      <form #form="ngForm" (ngSubmit)="updateCompany()">
        <div class="row mb-3">
          <div class="col-sm-4" style="text-align: left">
            <label for="name" class="form-label">Name :</label>
          </div>
          <div class="col-sm-8">
            <input
              type="text"
              class="form-control border border-dark"
              id="name"
              name="name"
              [(ngModel)]="companyDetails.Name"
            />
          </div>
        </div>

        

        <div class="row mb-3">
          <div class="col-sm-4" style="text-align: right">
            <button type="submit" class="btn custom-buttons-btn">Update</button>
          </div>
          <div class="col-sm-4" style="text-align: left">
            <button
              type="button"
              class="btn custom-delete-btn"
              (click)="deleteCompany(companyDetails.Id)"
            >
              Delete
            </button>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-sm-4" style="text-align: right">Users:</div>
          <div class="col" style="text-align: left">
            <a
              style="color: black"
              [routerLink]="['/user/user-add']"
              [queryParams]="{
                companyId: companyDetails.Id,
              }"
              >Add Users</a>
          </div>
        </div>
        <div class="row mb-1" *ngFor="let user of userList">
          <div class="col-sm-4" style="text-align: right"></div>
          <div class="col" style="text-align: left">
            <a
              style="color: black"
              (click)="navigatToUser(user.Id)"
              >{{ user.FirstName }} {{ user.LastName }} ( {{ user.Email }} )</a
            >
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
